import { createAsyncThunk } from "@reduxjs/toolkit";
import client from "../../../app/core/client-http/client";

export const addOtherServices = createAsyncThunk(
  "addOtherServices/edit",
  async (serviceData, thunkAPI) => {
    const endpoint = "admin/studio/addotherservice";
    const response = await client.post(endpoint, serviceData);
    return response.data; // Risposta che contiene i dati dell'utente creato
  }
);

export const removeOtherServices = createAsyncThunk(
  "removeOtherServices/edit",
  async (serviceData, thunkAPI) => {
    const endpoint = "admin/studio/removeotherservice";
    const response = await client.post(endpoint, serviceData);
    return response.data; // Risposta che contiene i dati dell'utente creato
  }
);
